__turbopack_context__.v({
  "closedArrow": "ButtonAction-module__fDAh4a__closedArrow",
  "label": "ButtonAction-module__fDAh4a__label",
  "openArrow": "ButtonAction-module__fDAh4a__openArrow",
});
